import { isTRPCClientError } from '@trpc/client';

/**
 * Whether a `getCurrent` failure during the login callback means the caller is a
 * genuine first-login user — a valid, email-verified token with no local account
 * yet — and so should be provisioned.
 *
 * Only a backend `UNAUTHORIZED` qualifies: session hydration rejects when there
 * is no user record behind the token. Every other failure (transient backend
 * error, timeout, a propagated compliance error) is a real fault that must
 * surface, not be masked by a provisioning write.
 *
 * @param error - The thrown value from the `getCurrent` query.
 * @returns `true` only for a tRPC `UNAUTHORIZED` client error.
 */
export function isUnprovisionedUserError(error: unknown): boolean {
	return isTRPCClientError(error) && (error.data as { code?: string } | null | undefined)?.code === 'UNAUTHORIZED';
}
